import React, { useState } from "react";
import { Box, TextField, Typography, Button } from "@mui/material";
import axios from "axios";
import backgroundImage from "../../assets/Bathroom1..jpg";

const RequestForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    projectType: "",
    city: "",
    description: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        "https://prorenovations.info/api/sendEmail/send",
        {
          username: formData.name,
          email: formData.email,
          phoneNumber: formData.phone,
          subject: formData.projectType,
          message: formData.description,
          city: formData.city,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        alert("Your massage successfully sent");
      } else {
        alert(response.data.error || "Error");
      }
    } catch (error) {
      console.error("Error sending email:", error);
      alert("Error");
    }
  };

  return (
    <Box
      id="requestForm"
      sx={{
        display: "flex",
        justifyContent: { xs: "center", md: "flex-end" },
        alignItems: "center",
        height: "100vh",
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        position: "relative",
        padding: { xs: "20px", md: "0 70px" },
      }}
    >
      <Box
        sx={{
          width: { xs: "100%", sm: "80%", md: "40%" },
          backgroundColor: "#4e77fa",
          padding: { xs: "20px", md: "30px" },
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        }}
      >
        <Typography
          variant="h4"
          sx={{
            color: "white",
            marginBottom: "20px",
            fontSize: { xs: "24px", md: "32px" },
          }}
        >
          Request a <strong>Free, No-Obligation</strong> Bathroom Remodel Quote
          & Expert Advice!
        </Typography>
        <form noValidate autoComplete="off" onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            variant="outlined"
            margin="normal"
            sx={{ backgroundColor: "white", borderRadius: "5px" }}
          />
          <Box
            sx={{
              display: "flex",
              gap: "10px",
              flexDirection: { xs: "column", md: "row" },
            }}
          >
            <TextField
              fullWidth
              label="Email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              variant="outlined"
              margin="normal"
              sx={{ backgroundColor: "white", borderRadius: "5px" }}
            />
            <TextField
              fullWidth
              label="Phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              variant="outlined"
              margin="normal"
              sx={{ backgroundColor: "white", borderRadius: "5px" }}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              gap: "10px",
              flexDirection: { xs: "column", md: "row" },
            }}
          >
            <TextField
              fullWidth
              label="Type of Project"
              name="projectType"
              value={formData.projectType}
              onChange={handleChange}
              variant="outlined"
              margin="normal"
              sx={{ backgroundColor: "white", borderRadius: "5px" }}
            />
            <TextField
              fullWidth
              label="City"
              name="city"
              value={formData.city}
              onChange={handleChange}
              variant="outlined"
              margin="normal"
              sx={{ backgroundColor: "white", borderRadius: "5px" }}
            />
          </Box>
          <TextField
            fullWidth
            label="Describe Your Project"
            name="description"
            value={formData.description}
            onChange={handleChange}
            variant="outlined"
            margin="normal"
            multiline
            rows={4}
            sx={{ backgroundColor: "white", borderRadius: "5px" }}
          />
          <Button
            fullWidth
            type="submit"
            variant="contained"
            sx={{
              backgroundColor: "black",
              color: "white",
              padding: "15px",
              marginTop: "20px",
              fontWeight: "bold",
              fontSize: { xs: "14px", md: "16px" },
            }}
          >
            Get A FREE Estimate
          </Button>
        </form>
      </Box>
    </Box>
  );
};

export default RequestForm;
